import {Action, getModule, Module, Mutation, VuexModule} from "vuex-module-decorators";
import store from "@/store";
import {CustomerRegister} from "@/interfaces/entity";
import {IdMapper} from "@/interfaces/state/base";
import {PaginationMeta} from "@/interfaces/common";
import {CustomerRegisterState} from "@/interfaces/state/customerregiser";
import {CustomerRegisterParams} from "@/modules/customerregister/params";
import {
    confirmCustomerRegister,
    deleteCustomerRegister,
    listCustomerRegister,
    singleCustomerRegister
} from "@/modules/customerregister/services";

@Module({ dynamic: true, name: "customer", store })
class CustomerRegisterModule extends VuexModule implements CustomerRegisterState {
    data: IdMapper<CustomerRegister> = {};
    ids: number[] = [];
    meta: PaginationMeta = new PaginationMeta();
    params: CustomerRegisterParams = new CustomerRegisterParams();

    get customerRegisters() {
        return this.ids.map((id: number) => this.data[id]);
    }

    @Mutation
    private UPDATE_CUSTOMER_REGISTER_PARAMS(payload: any) {
        this.params = payload;
    }

    @Mutation
    private MAP_CUSTOMER_REGISTER(payload: any) {
        const idMapper: IdMapper<CustomerRegister> = {};
        this.meta = payload.meta;
        this.ids = payload.datas?.map((cr: CustomerRegister) => {
            idMapper[cr.id!] = {...cr, isDeleting: false};
            return cr.id;
        });
        this.data = idMapper;
    }

    @Mutation
    private ADD_CUSTOMER_REGISTER(payload: CustomerRegister) {
        if (!payload || this.ids.includes(payload.id) || this.data[payload.id]) return;
        this.ids = [ ...this.ids, payload.id ];
        this.data = { ...this.data, [payload.id]: {...payload, isDeleting: false} }
    }

    @Mutation
    private UPDATE_CUSTOMER_REGISTER(payload: CustomerRegister) {
        if (!this.data[payload.id] || !this.ids.includes(payload.id)) return;
        this.data[payload.id] = { ...payload, isDeleting: false }
    }

    @Mutation
    private DELETE_CUSTOMER_REGISTER(payload: CustomerRegister) {
        if (!this.data[payload.id] || !this.ids.includes(payload.id)) return;
        this.ids = this.ids.filter((id: number) => id !== payload.id);
        delete this.data[payload.id];
    }

    @Mutation
    private START_DELETE_CUSTOMER_REGISTER(id: number) {
        this.data[id].isDeleting = true;
    }

    @Mutation
    private END_DELETE_CUSTOMER_REGISTER(id: number) {
        this.data[id].isDeleting = false;
    }

    @Action
    public updateCustomerRegisterParams(payload: any){
        this.UPDATE_CUSTOMER_REGISTER_PARAMS(payload);
    }

    @Action({ rawError: true })
    public addCustomerRegister(payload: CustomerRegister) {
        this.ADD_CUSTOMER_REGISTER(payload);
    }

    @Action({ rawError: true })
    public async confirmCustomerRegister(form: any) {
        const { data } = await confirmCustomerRegister(form.id, form);
        this.ADD_CUSTOMER_REGISTER(data.data);
    }

    @Action({ rawError: true })
    public async listCustomerRegister(params: CustomerRegisterParams = new CustomerRegisterParams()) {
        const { data } = await listCustomerRegister(params);
        this.MAP_CUSTOMER_REGISTER(data);
    }

    @Action({ rawError: true })
    public async singleCustomerRegister(id: number) {
        const { data } = await singleCustomerRegister(id);
        return data.data;
    }

    @Action({ rawError: true })
    public async deleteCustomerRegister(id: number) {
        this.START_DELETE_CUSTOMER_REGISTER(id);
        const { data } = await deleteCustomerRegister(id);
        this.END_DELETE_CUSTOMER_REGISTER(id);
        console.log(data.data);
        this.DELETE_CUSTOMER_REGISTER(data.data);
    }

}

export const CustomerRegisterStore = getModule(CustomerRegisterModule);
